import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/** The class-name merge every component uses. Later classes win conflicts. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
